import { render } from "./Carousel.vue?vue&type=template&id=3a91c0c6&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=3a91c0c6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a91c0c6"]])

export default __exports__